module.exports = __webpack_public_path__ + "media/bgm.bdcc3e5f.mp3";